import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EMAIL_VALIDATOR_PATTERN } from '@core/constants/FomPatterns';
import { LOGIN } from '@core/constants/RoutingsPath';

@Component({
    selector: 'app-remember-form',
    templateUrl: './remember-form.component.html',
    styleUrls: ['./remember-form.component.scss'],
    standalone: false
})
export class RememberFormComponent implements OnInit {
  form: any = this.initForm();
  isSubmited = false;
  errorFeedbackList = this.loadFeedbackErrorLists();
  loginPath = `/${LOGIN}`;

  @Output() submitForm: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.errorFeedbackList = this.loadFeedbackErrorLists();
  }

  onSubmit() {
    this.isSubmited = true;
    if (this.form && this.form.valid) {
      this.submitForm.emit(this.form.value);
    }
  }

  private initForm(): UntypedFormGroup {
    return this.fb.group({
      email: [
        '',
        [Validators.required, Validators.pattern(EMAIL_VALIDATOR_PATTERN)]
      ]
    });
  }

  private loadFeedbackErrorLists() {
    return {
      email: {
        required: 'form.errors.required',
        pattern: 'form.errors.emailLoginPattern'
      },
      password: {
        required: 'form.errors.required'
      },
      repeatPassword: {
        required: 'form.errors.required',
        mustMatch: 'form.errors.not-match-password'
      }
    };
  }
}
